import React, { useRef, useEffect } from 'react';
import { Image, Transformer } from 'react-konva';
import useImage from 'use-image';
import Konva from 'konva';
import { ICON } from './DeleteButtonIcon';

const ImageContainer = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  handleDelete
}) => {
  const [image, status] = useImage(shapeProps.URL);
  const [icon] = useImage(ICON);

  const shapeRef = useRef();
  const trRef = useRef();

  const calculateAspectRatioFit = (
    srcWidth,
    srcHeight,
    maxWidth,
    maxHeight
  ) => {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
  };

  useEffect(() => {
    if (status === 'loaded') {
      const node = shapeRef.current;
      const width = node.width();
      const height = node.height();

      const resizeImage = calculateAspectRatioFit(
        width,
        height,
        375 - 20,
        510 - 20
      );

      if (width > 375 || height > 510) {
        onChange({
          ...shapeProps,
          height: resizeImage.height,
          width: resizeImage.width
        });
      }
    }
  }, [status]);

  useEffect(() => {
    if (isSelected) {
      const tr = trRef.current;
      tr.nodes([shapeRef.current]);

      const deleteButton = new Konva.Image({
        image: icon,
        height: 20,
        width: 20
      });

      deleteButton.on('click', () => {
        handleDelete();
      });

      deleteButton.on('tap', () => {
        handleDelete();
      });

      tr.add(deleteButton);

      tr.update = function () {
        Konva.Transformer.prototype.update.call(tr);

        const { x, y } = tr.findOne('.top-right').position();

        deleteButton.position({ x: x + 7, y: y - 23 });
      };

      tr.update();
      tr.getLayer().draw();
    }
  }, [isSelected]);

  return (
    <>
      <Image
        image={image}
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable
        onDragStart={onSelect}
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={(e) => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default ImageContainer;
